const e = "af.ccd.open", o = "af.ccd-tour.close", s = class s extends CustomEvent {
  constructor() {
    super(e, { bubbles: !0, composed: !0 });
  }
};
s.OPEN_CCD_EVENT = e;
let C = s;
const t = class t extends CustomEvent {
  constructor() {
    super(o, { bubbles: !0, composed: !0 });
  }
};
t.CLOSE_CCD_TOUR_EVENT = o;
let E = t;
export {
  o as CLOSE_CCD_TOUR_EVENT,
  E as CloseCCDTourEvent,
  e as OPEN_CCD_EVENT,
  C as OpenCCDEvent
};
//# sourceMappingURL=CCDEvent.js.map
